(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer-r2"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header-r2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlb-collars"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.mlbReady) return;
      var track = root.querySelector('[data-mlb-track]');
      var slides = root.querySelectorAll('[data-mlb-slide]');
      if (!track || slides.length < 2) return;
      root.mlbReady = true;

      var label = root.querySelector('[data-mlb-label]');
      var dots = root.querySelectorAll('[data-mlb-dot]');
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;

      function show(index) {
        if (index === current) return;
        current = index;
        if (label) label.textContent = slides[index].getAttribute('data-label') || '';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function nearest() {
        var width = track.clientWidth || 1;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      }

      function go(index) {
        var count = slides.length;
        var target = ((index % count) + count) % count;
        track.scrollTo({ left: target * track.clientWidth, behavior: calm ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', function () {
        show(nearest());
      }, { passive: true });

      var prev = root.querySelector('[data-mlb-prev]');
      var next = root.querySelector('[data-mlb-next]');
      if (prev) prev.addEventListener('click', function () { used(); go(current - 1); });
      if (next) next.addEventListener('click', function () { used(); go(current + 1); });

      function used() {
        root.classList.add('is-used');
        root.classList.remove('is-hinting');
      }

      track.addEventListener('touchstart', used, { passive: true, once: true });
      track.addEventListener('pointerdown', used, { once: true });

      if (!calm && 'IntersectionObserver' in window) {
        var seen = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            seen.disconnect();
            if (!root.classList.contains('is-used')) root.classList.add('is-hinting');
          });
        }, { threshold: 0.6 });
        seen.observe(track);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { go(i); });
      });

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); go(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(current - 1); }
      });

      /* Mouse drag, so desktop visitors can pull the collar through as well. Touch uses native scrolling. */
      var startX = 0;
      var startLeft = 0;
      var dragging = false;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        startX = event.clientX;
        startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        track.scrollLeft = startLeft - (event.clientX - startX);
      });

      function release(event) {
        if (!dragging) return;
        dragging = false;
        var moved = event.clientX - startX;
        var index = Math.round(startLeft / (track.clientWidth || 1));
        if (Math.abs(moved) > 40) index += moved < 0 ? 1 : -1;
        index = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: index * track.clientWidth, behavior: calm ? 'auto' : 'smooth' });
        window.setTimeout(function () { track.classList.remove('is-dragging'); }, calm ? 0 : 350);
      }

      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);

      /* In the theme editor, selecting a collar block brings it into view. */
      slides.forEach(function (slide, i) {
        slide.addEventListener('shopify:block:select', function () { go(i); });
      });
    }

    function setupAll() {
      document.querySelectorAll('[data-mlb-collars]').forEach(setup);
    }

    setupAll();
    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlb-how"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.mlbReady) return;
      root.mlbReady = true;

      var track = root.querySelector('[data-mlb-track]');
      var cards = root.querySelectorAll('[data-mlb-card]');
      var dots = root.querySelectorAll('[data-mlb-dot]');
      var videos = root.querySelectorAll('video');
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      videos.forEach(function (video) {
        video.muted = true;
        video.setAttribute('playsinline', '');
        if (calm) {
          video.removeAttribute('autoplay');
          video.pause();
        }
      });

      function live(on) {
        root.classList.toggle('is-live', on);
        if (calm) return;
        videos.forEach(function (video) {
          if (on) {
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      if ('IntersectionObserver' in window) {
        root.classList.add('mlb-how--armed');
        if (calm) root.classList.add('is-in');

        var seen = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            root.classList.add('is-in');
            seen.disconnect();
          });
        }, { threshold: 0.2 });
        seen.observe(root);

        var near = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            live(entry.isIntersecting);
          });
        }, { rootMargin: '150px 0px' });
        near.observe(root);
      }

      if (!track || !dots.length) return;

      function mark() {
        var max = track.scrollWidth - track.clientWidth;
        var index = max > 4 ? Math.round((track.scrollLeft / max) * (cards.length - 1)) : 0;
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function go(i) {
        var card = cards[i];
        if (!card) return;
        var pad = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft - pad, behavior: calm ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', mark, { passive: true });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { go(i); });
      });
      cards.forEach(function (card, i) {
        card.addEventListener('shopify:block:select', function () { go(i); });
      });
      mark();
    }

    function setupAll() {
      document.querySelectorAll('[data-mlb-how]').forEach(setup);
    }

    setupAll();
    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlb-promise"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.mlbReady) return;
      root.mlbReady = true;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      root.classList.add('mlb-promise--armed');
      var seen = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            root.classList.add('is-in');
            seen.disconnect();
          });
        },
        { threshold: 0.4 }
      );
      seen.observe(root);
    }

    function setupAll() {
      document.querySelectorAll('[data-mlb-promise]').forEach(setup);
    }

    setupAll();
    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlb-scroll-capsule"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
    var ease = function (t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };

    function setup(el) {
      if (el.hasAttribute('data-mlb-ready')) return;
      el.setAttribute('data-mlb-ready', '');
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var num = function (name, fallback) { var v = parseFloat(el.getAttribute(name)); return isNaN(v) ? fallback : v; };
      var hx = num('data-hole-x', 58), hy = num('data-hole-y', 75);
      var sx = num('data-start-x', 50), sy = num('data-start-y', 22);
      var ss = num('data-start-scale', 130) / 100;
      var steps = el.querySelectorAll('.mlb-pop__step');
      var fill = el.querySelector('.mlb-pop__ring-fill');
      var ticking = false;
      el.style.setProperty('--mlb-hx', hx);
      el.style.setProperty('--mlb-hy', hy);
      el.classList.add('mlb-pop--live');

      function render() {
        ticking = false;
        var rect = el.getBoundingClientRect();
        var travel = el.offsetHeight - window.innerHeight;
        var p = travel > 0 ? clamp(-rect.top / travel) : 1;

        var move = ease(clamp((p - 0.1) / 0.46));           /* capsule travels in */
        var press = clamp((p - 0.56) / 0.1);                 /* small squash as it seats */
        var squash = 1 - 0.07 * Math.sin(press * Math.PI);
        var ring = clamp((p - 0.66) / 0.26);                 /* ring fills */

        el.style.setProperty('--mlb-x', sx + (hx - sx) * move);
        el.style.setProperty('--mlb-y', sy + (hy - sy) * move);
        el.style.setProperty('--mlb-s', (ss + (1 - ss) * move) * squash);
        el.style.setProperty('--mlb-lift', 1 - move);
        if (fill) { fill.style.strokeDashoffset = 100 - ring * 100; fill.style.opacity = ring > 0.001 ? 1 : 0; }
        el.style.setProperty('--mlb-ring-on', press >= 1 ? 1 : 0);
        el.style.setProperty('--mlb-badge', clamp((ring - 0.15) / 0.3));

        var n = steps.length;
        var active = n < 2 ? 0 : p < 0.14 ? 0 : p < 0.62 ? Math.min(1, n - 1) : n - 1;
        for (var i = 0; i < n; i++) steps[i].classList.toggle('is-active', i === active);
      }
      function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(render); } }
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      render();
    }

    function init() { document.querySelectorAll('[data-mlb-pop]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlb-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function countUp(el) {
      var target = parseFloat(el.getAttribute('data-mlb-count')) || 0;
      var delay = parseFloat(getComputedStyle(el.closest('.mlb-stats__item')).getPropertyValue('--mlb-delay')) || 0;
      var duration = 1400;
      var start = null;
      el.textContent = '0';
      function frame(now) {
        if (start === null) start = now + delay;
        var t = Math.min(Math.max((now - start) / duration, 0), 1);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = String(Math.round(target * eased));
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function unblend(el) {
      if (!el || !el.classList.contains('mlb-blend-below')) return;
      el.classList.remove('mlb-blend-below');
      el.style.removeProperty('margin-top');
    }

    function blend(root) {
      var wrap = root.closest('.shopify-section');
      if (!wrap) return;
      var next = wrap.nextElementSibling;
      var on = root.getAttribute('data-mlb-blend') === 'true' && next && next.querySelector('.section-border');
      if (root.mlbNext && root.mlbNext !== next) unblend(root.mlbNext);
      if (!on) {
        root.style.removeProperty('--mlb-overlap');
        unblend(next);
        root.mlbNext = null;
        return;
      }
      next.classList.add('mlb-blend-below');
      next.style.marginTop = '0px';
      var height = next.offsetHeight;
      next.style.marginTop = -height + 'px';
      root.style.setProperty('--mlb-overlap', height + 'px');
      if (root.mlbNext !== next && 'ResizeObserver' in window) {
        if (root.mlbWatch) root.mlbWatch.disconnect();
        root.mlbWatch = new ResizeObserver(function () {
          var now = next.offsetHeight;
          if (Math.abs(now - parseFloat(root.style.getPropertyValue('--mlb-overlap') || '0')) > 0.5) blend(root);
        });
        root.mlbWatch.observe(next);
      }
      root.mlbNext = next;
    }

    function blendAll() {
      document.querySelectorAll('[data-mlb-stats]').forEach(blend);
    }

    function setup(root) {
      if (!root || root.getAttribute('data-mlb-ready')) return;
      root.setAttribute('data-mlb-ready', 'true');
      blend(root);
      if (reduce || !('IntersectionObserver' in window)) return;

      root.classList.add('mlb-stats--armed');
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            entry.target.classList.add('is-in');
            var counter = entry.target.querySelector('[data-mlb-count]');
            if (counter) countUp(counter);
          });
        },
        { threshold: 0.4 }
      );
      root.querySelectorAll('.mlb-stats__item').forEach(function (item) {
        observer.observe(item);
      });
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-mlb-stats]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
      blendAll();
    });
    document.addEventListener('shopify:section:unload', function () {
      window.setTimeout(blendAll, 50);
    });
    document.addEventListener('shopify:section:reorder', blendAll);
    window.addEventListener('load', blendAll);
    window.addEventListener('resize', blendAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlb-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setup(root) {
      if (!root || root.getAttribute('data-mlb-ready')) return;
      root.setAttribute('data-mlb-ready', 'true');

      root.addEventListener('click', function (event) {
        var step = event.target.closest('.mlb-tl__step');
        if (!step || !root.contains(step)) return;
        var wasActive = step.classList.contains('is-active');
        root.querySelectorAll('.mlb-tl__step.is-active').forEach(function (other) {
          other.classList.remove('is-active');
        });
        if (!wasActive) step.classList.add('is-active');
      });

      if (reduce || !('IntersectionObserver' in window)) return;

      root.classList.add('mlb-tl--armed');
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            entry.target.classList.add('is-in');
            window.setTimeout(function () {
              entry.target.classList.add('is-done');
            }, 1800);
          });
        },
        { threshold: 0.3 }
      );
      root.querySelectorAll('.mlb-tl__step').forEach(function (step) {
        observer.observe(step);
      });
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-mlb-tl]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
